import React from "react"
import { Link } from "gatsby"
import { ChevronDown } from "react-feather"
import styles from "./header.module.css"

type SubMenuItemProps = {
  name: string
  id: number
  subLinks: Array<{ name: string; page: string; id: number }>
  open: boolean
  openTrigger: (id: number) => Function
}

export const SubMenuItem = ({
  name,
  subLinks,
  id,
  open,
  openTrigger,
}: SubMenuItemProps) => {
  return (
    <li
      className={`relative ${styles.headerNavigationLinkItem}`}
      tabIndex={0}
      key={`navigation-item-${id}`}
      data-testid="subLinkMenu"
      onClick={e => {
        if (open) {
          openTrigger(0)
        } else {
          e.stopPropagation()
          openTrigger(id)
        }
      }}
    >
      <span className="flex items-center py-1 font-mono font-medium tracking-wide uppercase text-blackNew">
        <span>{name}</span>
        <ChevronDown
          className="ml-px transition-transform duration-300"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
          size="12"
        />
      </span>

      <div
        onClick={e => e.stopPropagation()}
        style={{ minWidth: "240px" }}
        className={`pointer-events-none absolute top-full left-0 transition-all duration-200 ${
          open
            ? "opacity-100 translate-y-0 visible"
            : "opacity-0 -translate-y-2 invisible"
        }`}
      >
        <div className="px-8 py-6 cursor-default pointer-events-auto border-t-1 border-b-1 border-borderColour bg-white shadow-md">
          <ul className="flex flex-col gap-y-4">
            {subLinks.map(({ name, page, id }) => (
              <li key={`SubMenuItem-${id}`} style={{ whiteSpace: "nowrap" }}>
                <Link
                  className="normal-case font-sans text-sm transition-colors duration-150 hover:text-gold600"
                  to={page}
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </li>
  )
}
